angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CREATE_TRIP": {
    "ERROR": {
      "ALREADY-EXISTS": "Cannot create multiple trips to the same location",
      "TRIP-TO-HOMELOCATION": "Cannot create a trip to your home location",
      "GENERIC_ERROR": "Cannot create this trip",
      "LOCATION_INVALID": "Invalid location",
      "REQUIRED_ONE": "Select at least one",
      "DATE": "Select a date",
    },
    "SUCCESS": {
      "HEADER": "New Trip created",
      "BODY": "Congratulations! You’ve successfully created a new trip. Available locals will send you offers for your visit. They will appear in your Showaround inbox.",
      "LABEL": "OK, got it",
    },
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/trips/my_trips/create_trip_form/create_trip.json
// module id = 424
// module chunks = 24